/*
 * ******************************************************************
 * Copyright (c) 2021-2024 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */

import { OAuth2ModuleConfiguration } from "@vmw/ngx-csp-oauth2";
import { CspEnvironment } from "@vmw/csp-ngx-components";
import { ServiceTypeEnum } from "@api/generated/vcdr";
import { ConsoleType } from "@shared/models/global.model";

export const CSP_SESSION_STORAGE_METHOD: any = "session";
export const CSP_PRODUCTION_HOST: string = "https://console.cloud.vmware.com";
export const CSP_STAGING_HOST: string = "https://console-stg.cloud.vmware.com";

export enum ServiceState {
    DISABLED = 0,
    ENABLED_MANAGED = 1,
    ENABLED_SELF_SERVICE = 2
}

export class ServiceConfig {
    serviceState: ServiceState;
    clientId: string;
    serviceId: string;
    selfServiceConsole: ConsoleType;
    features: Feature[];
}

export class Feature {
    public static SUBSCRIPTION_CHARTS = new Feature("SUBSCRIPTION_CHARTS");
    public static INVENTORY_REFRESH = new Feature("INVENTORY_REFRESH");
    public static QUICK_PLANNER_VMS = new Feature("QUICK_PLANNER_VMS");
    public static DEPLOYMENT_FILTERS = new Feature("DEPLOYMENT_FILTERS");
    public static TENANT_UPGRADE = new Feature("TENANT_UPGRADE");
    public static CHANGE_OFFLINE_LICENSE_KEY = new Feature("CHANGE_OFFLINE_LICENSE_KEY");

    private params: any[];

    constructor(private featureName: string) {
    }

    public withParams(params: any[]): Feature {
        this.params = params;
        return this;
    }

    public equalTo(feature: Feature): boolean {
        return this.featureName === feature.featureName
            && JSON.stringify(this.params) === JSON.stringify(feature.params);
    }

}

export interface AppConfig {
    production: boolean;
    vipHost: string;

    // Operator console
    opConsoleApiServer: string;
    opConsoleOrgId: string;
    opConsoleClientId: string;
    opConsoleServiceId: string;

    // Self-service consoles
    selfServiceApiServer: string;
    services: Map<ServiceTypeEnum, ServiceConfig>;

    cspServiceId: string; // TODO: deprecate this as there are now multiple CSP service IDs.
    cspEnvironment: CspEnvironment,
    cspOAuthConfig: Partial<OAuth2ModuleConfiguration>;
}
